import { ActeurIcon } from "@logora/parliament.icons.regular_icons";
import { formatActeur, formatCapitalize, formatCell } from "../formatters";

const columns = [
    {
        header: "Nom",
        accessorKey: "acteurRef",
        sortBy: "acteurRef_nom",
        cell: (info) => formatActeur(formatCell(info)),
        enableSorting: false,
    },
    {
        header: "Qualité",
        accessorKey: "codeQualite",
        cell: (info) => formatCapitalize(formatCell(info)),
        enableSorting: false,
    },
    {
        header: "Circonscription",
        accessorKey: "acteurRef.circonscription.libelle",
        enableSorting: false,
    },
    {
        header: "Commission permanente",
        accessorKey: "acteurRef.commissionPermanente.libelle",
        enableSorting: false,
    },
    {
        header: "Actif",
        accessorKey: "actif",
        isVisible: false,
        enableSorting: false,
        meta: {
            filter: {
                label: "Actif",
                variant: "boolean",
                defaultValue: true,
                showInFilterBar: false,
            },
        },
    },
    {
        header: "Nomination principale",
        accessorKey: "nominPrincipale",
        isVisible: false,
        enableSorting: false,
        meta: {
            filter: {
                label: "Nomination principale",
                variant: "boolean",
                defaultValue: true,
                showInFilterBar: false,
            },
        },
    },
];

export const mandatDataset = {
    key: "mandats",
    name: "Mandats",
    columns: columns,
    include: [
        "acteurRef.groupeParlementaire",
        "acteurRef.mandatPrincipal",
        "acteurRef.commissionPermanente",
    ],
    searchTable: "acteurRef",
    searchPlaceholder: "Chercher un parlementaire...",
    icon: <ActeurIcon height={20} width={20} />,
    rowRedirect: (item) => `/parliament/acteurs/${item.acteurRefUid}`,
};
